import { createSlice } from "@reduxjs/toolkit";


const rereshFilterSlice = createSlice({
  name: "refreshPage",
  initialState: { actionDataList: [] },
  reducers: {
    selectList: (state, action) => {
      state.actionDataList = action.payload;
    },
  },
});

export const { selectList } = rereshFilterSlice.actions;

// Export reducer
export default rereshFilterSlice.reducer;
